export function getRuntimeConfigValue(key, fallback = '') {
  if (typeof window !== 'undefined') {
    const value = window.__PROFITEIA_CONFIG__?.[key];
    if (typeof value === 'string' && value.trim()) {
      return value;
    }
  }

  return fallback;
}

export function normalizeApiBaseUrl(value) {
  if (typeof value !== 'string' || !value.trim()) {
    return value;
  }

  // Strip surrounding quotes: a mis-set env var / CI variable can arrive as
  // `"https://api.profiteia.io/api/v2"` (literal quotes), which is not a valid
  // URL and would otherwise fall through unusable. See normalizeBaseDomain.
  const cleaned = value.trim().replace(/^["']+|["']+$/g, '').trim();

  try {
    const url = new URL(cleaned);
    if (url.hostname === 'api.prod.profiteia.io') {
      url.hostname = 'api.profiteia.io';
      url.protocol = 'https:';
    }
    return url.toString();
  } catch {
    return cleaned;
  }
}

export function getApiBaseUrl(fallback = process.env.VUE_APP_API_BASE_URL) {
  return normalizeApiBaseUrl(getRuntimeConfigValue('VUE_APP_API_BASE_URL', fallback));
}

export function getAppEnvironment(fallback = process.env.VUE_APP_ENVIRONMENT) {
  return getRuntimeConfigValue('VUE_APP_ENVIRONMENT', fallback);
}
